import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import { Link } from 'react-router-dom';
import Select from '@material-ui/core/Select';
import ReactCountryFlag from "react-country-flag"
import { constants } from '../constants';
import { HashLink } from 'react-router-hash-link';
import { useTranslation } from 'react-i18next';


const useStyles = makeStyles((theme) => ({
  country: {
    width: '150px'
  },
  flagthis: {
    width: '30px',
    marginRight: '10px'
  }
}));


const TheHeader = ({changeLangClass}) => {
  const { t: homeT } = useTranslation('home');
  const { t: headerT } = useTranslation('header');
  const { t, i18n } = useTranslation();
  const [divClass, setDivClass] = useState('');
  const dispatch = useDispatch();
  const classes = useStyles();
  const user = useSelector(state => state.user);
  const [sidemenu, SetSidemenu] = useState(false);
  const [countryList, SetCountryList] = useState(null);
  const [countryCode, SetCountryCode] = useState(user.countryCode);


  useEffect(() => {
    if (user.countryList) {
      SetCountryList(user.countryList);
      SetCountryCode(user.countryCode);
    }
  }, [user.countryList]);




  const HandleCountryChange = (e) => {
    if (e.target.value) {
      dispatch({ type: constants.SET_COUNTRY_CODE, value: e.target.value });
    }
  }
  const GetCartCount = () => {
    console.log('GetCartCount');
}

// Step 2: Function to change the class
const changeLangClassH = (lang) => {
  console.log('selected_lang:'+lang);
  i18n.changeLanguage(lang);
    dispatch({ type: constants.SET_LANGUAGE, value: lang });
    localStorage.setItem('spuserlang', lang);
  
  const langClass = lang == 'en' ? 'english-E' : '';
  setDivClass(langClass); 
  changeLangClass(lang);
};

const handleLanguageChange = () => {
  // Toggle language between 'en' and 'ar'
  const newLang = i18n.language === 'en' ? 'ar' : 'en';
  changeLangClassH(newLang);
};
const handleLanguageChange2 = () => {
  // Toggle language between 'en' and 'ar'
  const newLang = i18n.language === 'en' ? 'ar' : 'en';
  changeLangClassH(newLang);
};

  return (
    <React.Fragment>
      {/* <!-- header --> */}
      <header id="home" class="site-header">
    <nav class="navbar navbar-expand-lg center-brand static-nav">
        <div class="container-fluid">
            <a class="navbar-brand" href="/dashboard">
                <img src="src/images/logo.png" alt="logo"></img>
            </a>
            <button class="navbar-toggler navbar-toggler-right collapsed d-none" type="button" data-toggle="collapse" data-target="#xenav">
                <span> </span>
                <span> </span>
                <span> </span>
            </button>
            <div class="collapse navbar-collapse" id="xenav">
                <ul class="navbar-nav ml-auto">
                    <li class="nav-item">
                        <HashLink className="nav-link" to="/home">  <img src='src/images/icons/catelog.svg' /> {headerT('Subjects')}</HashLink>
                    </li>
                    <li class="nav-item">
                        <Link className="nav-link" to="/privateclass" > <img src='src/images/icons/privateclass.svg' /> {headerT('Request a private Class')}</Link>
                    </li>
                    <li class="nav-item">
                        <a className="nav-link" href="tel:+9651881880" title="Call Us"> <img src='src/images/icons/call-us.svg' /> {headerT('Contact us')} </a>
                    </li>
                    <li class="nav-item">
                    <Link to="/cart" className='nav-link'>
                    <img src="src/images/icons/cart.svg"></img> {headerT('Shopping Cart')}  {user.cartCount > 0 ?
                      <sup>{user.cartCount}</sup>
                      : null}
                    </Link>
                    </li>
                </ul>
                <li class="language-btn">
                    <a className="nav-link" onClick={handleLanguageChange} href="javascript:void(0)">
                                    <img src="src/images/icons/language.svg" alt="Language Icon" /> 
                                    {i18n.language === 'en' ? 'عربي' : 'English'}
                                </a>
                </li>
            </div>
            <div class="login">
              <a href="https://app.spediaapp.com/" target="_blank"> <button>{headerT('Enter')}</button></a>
            </div>
            <div class="cart-icon">
                <a href="/cart" title="Cart"> <img src="src/images/icons/cart.svg"></img>  {user.cartCount > 0 ?
                <sup>{user.cartCount}</sup>
                : null}</a>
            </div>
            
        </div>
      
        <a href="javascript:void(0)" class=" sidemenu_btn" id="sidemenu_toggle">
            <span></span> <span></span> <span></span>
        </a>
    </nav>

    <div class="side-menu">
        <div class="inner-wrapper">
            <span class="btn-close" id="btn_sideNavClose"><i></i><i></i></span>
            <nav class="side-nav w-100">
                <ul class="navbar-nav">
                    <li class="nav-item">
                        <a class="nav-link" href="/home" target="_blank"> <img src="src/images/icons/catelog.svg"></img>   {headerT('Subjects')}</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="/privateclass"> <img src="src/images/icons/privateclass.svg"></img> {headerT('Request a private Class')}</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="tel:+9651881880" title="Call US"> <img src="src/images/icons/call-us.svg"></img> {headerT('Contact us')}</a>
                    </li>
                    <li class="nav-item">
                    <a className="nav-link nokam" onClick={handleLanguageChange2}  href="javascript:void(0)">
                                    <img src="src/images/icons/language.svg" alt="Language Icon" /> 
                                    {i18n.language === 'en' ? 'عربي' : 'English'}
                                </a>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</header>
      {/* <!-- header --> */}
    </React.Fragment>
  )
}

export default TheHeader
